import { render, staticRenderFns } from "./StdCommDiscRates.vue?vue&type=template&id=5dbfec61&"
import script from "./StdCommDiscRates.vue?vue&type=script&lang=js&"
export * from "./StdCommDiscRates.vue?vue&type=script&lang=js&"
import style0 from "./StdCommDiscRates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdCommDiscRates.vue"
export default component.exports